import { createAction } from 'redux-act';
export var showModal = createAction('SHOW_MODAL');
export var dismissModal = createAction('DISMISS_MODAL');
export var setActiveModal = createAction('SET_ACTIVE_MODAL');